/**
 * The right-hand panel: a sensor-network graph fading into an ECG trace.
 *
 * Inline SVG rather than an image asset - it scales to any panel size without a
 * second request, and the palette is driven by the same SCSS custom properties
 * as the rest of the page, so retheming does not mean re-exporting artwork.
 */

const NODES: Array<[number, number, number]> = [
  [120, 90, 7], [250, 40, 5], [330, 150, 9], [190, 210, 6], [70, 260, 5],
  [420, 70, 6], [500, 190, 8], [390, 300, 5], [270, 330, 7], [140, 390, 6],
  [560, 90, 5], [640, 230, 7], [520, 360, 6], [400, 440, 8], [230, 470, 5],
  [700, 130, 6], [760, 300, 5], [660, 420, 7], [540, 500, 5], [330, 560, 6],
  [820, 210, 7], [880, 380, 5], [740, 540, 6], [600, 620, 5], [450, 660, 7],
];

const EDGES: Array<[number, number]> = [
  [0, 1], [0, 3], [1, 2], [2, 3], [2, 5], [3, 4], [3, 8], [5, 6], [6, 7],
  [6, 10], [7, 8], [8, 9], [9, 14], [10, 11], [11, 12], [11, 15], [12, 13],
  [13, 14], [13, 18], [15, 16], [16, 17], [16, 20], [17, 18], [18, 19],
  [19, 24], [20, 21], [21, 22], [22, 23], [23, 24], [12, 17], [7, 12],
  [2, 6], [6, 11], [11, 16], [4, 9], [14, 19], [22, 17],
];

/** A single heartbeat, repeated across the width by the path below. */
const ECG =
  'M0 60 L60 60 L74 60 L82 34 L92 86 L102 52 L112 60 L170 60 L184 60 ' +
  'L192 44 L200 76 L208 60 L260 60';

export function AuthArtwork() {
  return (
    <svg
      className="x5-auth__art-svg"
      viewBox="0 0 960 760"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
      focusable="false"
    >
      <g className="x5-auth__net">
        {EDGES.map(([a, b]) => {
          const from = NODES[a];
          const to = NODES[b];
          if (!from || !to) return null;
          return (
            <line
              key={`${a}-${b}`}
              x1={from[0]}
              y1={from[1]}
              x2={to[0]}
              y2={to[1]}
            />
          );
        })}
        {NODES.map(([cx, cy, r], i) => (
          <circle key={i} cx={cx} cy={cy} r={r} />
        ))}
      </g>

      {/* Two offset copies so the trace runs the full width without tiling seams. */}
      <g className="x5-auth__ecg" transform="translate(0 640)">
        <path d={ECG} />
        <path d={ECG} transform="translate(260 0)" />
        <path d={ECG} transform="translate(520 0)" />
        <path d={ECG} transform="translate(780 0)" />
      </g>
    </svg>
  );
}
